import { appendAsyncScript } from './append-async-script';
import {
  FACEBOOK_PIXEL_ID,
  INTERCOM_APP_ID,
  LINKEDIN_INSIGHT_ID,
  GOOGLE_ANALYTICS_ID,
  POSTHOG_API_KEY,
} from './environment';

export const ThirdPartyScripts = () => {
  /**
   * https://developers.facebook.com/docs/meta-pixel/get-started/?locale=fr_FR
   */
  const initFacebookPixel = () => {
    if (!FACEBOOK_PIXEL_ID || window.fbq) {
      return;
    }

    // eslint-disable-next-line func-names
    window.fbq = function () {
      if (window.fbq.callMethod) {
        // eslint-disable-next-line prefer-spread,prefer-rest-params
        window.fbq.callMethod.apply(window.fbq, arguments);
      } else {
        // eslint-disable-next-line prefer-rest-params
        window.fbq.queue.push(arguments);
      }
    };

    if (!window._fbq) {
      window._fbq = window.fbq;
    }

    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    appendAsyncScript(`https://connect.facebook.net/en_US/fbevents.js`);

    window.fbq('init', FACEBOOK_PIXEL_ID);
    window.fbq('consent', 'grant');
    window.fbq('track', 'PageView');
  };

  /**
   * https://www.linkedin.com/help/lms/answer/a418880
   */
  const initLinkedInInsight = () => {
    if (!LINKEDIN_INSIGHT_ID) {
      return;
    }

    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(LINKEDIN_INSIGHT_ID);

    if (!window.lintrk) {
      // eslint-disable-next-line func-names
      window.lintrk = function () {
        // eslint-disable-next-line prefer-rest-params
        window.lintrk.q.push(arguments);
      };

      window.lintrk.q = [];
    }

    appendAsyncScript(`https://snap.licdn.com/li.lms-analytics/insight.min.js`);
  };

  /**
   * https://developers.intercom.com/installing-intercom/web/installation/
   */
  const initIntercom = () => {
    if (!INTERCOM_APP_ID) {
      return;
    }

    window.intercomSettings = {
      app_id: INTERCOM_APP_ID,
    };

    if (window.Intercom && typeof window.Intercom === 'function') {
      window.Intercom('reattach_activator');
      window.Intercom('update', window.intercomSettings);
      return;
    }

    // eslint-disable-next-line func-names
    window.Intercom = function () {
      // eslint-disable-next-line prefer-rest-params
      window.Intercom.c(arguments);
    };
    window.Intercom.q = [];
    window.Intercom.c = (args) => {
      window.Intercom.q.push(args);
    };

    appendAsyncScript(`https://widget.intercom.io/widget/${INTERCOM_APP_ID}`);
  };

  const initDataLayer = () => {
    window.dataLayer = window.dataLayer || [];

    // eslint-disable-next-line func-names
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  };

  /**
   * https://developers.google.com/tag-platform/gtagjs/configure?hl=fr
   */
  const initGoogleAnalytics = () => {
    if (!GOOGLE_ANALYTICS_ID) {
      return;
    }

    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ANALYTICS_ID, {
      allow_enhanced_conversions: true,
      allow_linker: true,
      linker: {
        domains: ['convelio.com', 'web.convelio.com'],
      },
      page_title: 'Website',
      page_location: window.location.href,
    });

    appendAsyncScript(
      `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`
    );
  };

  const initPostHog = () => {
    // Snippet from https://posthog.com/docs/libraries/js
    /* eslint-disable */
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    /* eslint-enable */

    window.posthog.init(POSTHOG_API_KEY, {
      api_host: 'https://t.convelio.com',
      ui_host: 'https://eu.posthog.com',
      persistence: 'localStorage+cookie',
    });

    // Initial PostHog page view
    window.posthog.capture(
      '$pageview',
      window.posthog_page_view_properties || undefined
    );
  };

  return {
    initLinkedInInsight,
    initFacebookPixel,
    initIntercom,
    initDataLayer,
    initGoogleAnalytics,
    initPostHog,
  };
};
